import RejectedModule from "./RejectedModule";
import { useEffect, useState } from "react";

const RejectedManuscript = ({ modal,setModal , clientData , curationData ,manuscriptStatus ,freezeStatus}) => {

   const [firstCurationData, setfirstCurationData] = useState(); 
useEffect(() => {
  const firstMatchingRecord = curationData.listOfNonSimilarData.find(data => 
    data["llmTitleScoreFlagStatus"] === false &&
    data["authorStatusFlagStatus"] === false &&
    data["dateFlagFlagStatus"] === false &&
    data["llmAuthourScoreFlagStatus"] === false
);
  setfirstCurationData(firstMatchingRecord)
}, [curationData])

  const clickHandler = () => {
    setModal({
      show: true,
      modalType: "unresolved",
      header: "Unresolve Manuscript",
      message:
        "Are you sure you want to take unresolved action for this manuscript?",
      actionName: "Action",
      action: "Unresolve",
      clientData:clientData,
      curationData:firstCurationData
    });
  };

  return (
    <div className="col-md-6">
      <div className="">
        <div className="d-flex justify-content-between mb-3">
          <h5 className="card-title">Rejected Manuscript</h5>
          <button className="btn btn-outline-primary" onClick={clickHandler} disabled={manuscriptStatus !== 'noAction' |freezeStatus}>
            Unresolve
          </button>
        </div>
        {clientData && (
        <div className=" border rounded">
          <RejectedModule modal={modal} setModal={setModal} clientData={clientData} curationData={firstCurationData} />
        </div>
        )}
      </div>
    </div>
  );
};

export default RejectedManuscript;
